// imports
import "./components/navigation.js";
import LazyLoad from "vanilla-lazyload";
import "./components/modal.js";
import "./components/dropdown.js";
import "./components/law-circles.js";
import GLightbox from "glightbox"
import gsap from "gsap";
var Accordion = require("vanilla-js-accordion");
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
const $ = require("jquery");
var Accordion = require("vanilla-js-accordion");
var body = document.querySelector("body");
var html = document.querySelector("html");
var styleDir = object_name.stylesheetDirectory;
import Typed from 'typed.js';
setTimeout(function () {
  body.classList.add("ready");
}, 150);
console.log('app.js loaded');
setTimeout(function () {
  document.querySelector("#loading").remove();
}, 350);

function raf(time) {

  requestAnimationFrame(raf);
}
requestAnimationFrame(raf);


//lazy load options
const lazyLoadOptions = {};
const pageLazyLoad = new LazyLoad(lazyLoadOptions);
pageLazyLoad.update();




var faqAccordions = document.querySelectorAll(".accordion");
var faqAccordion = function () {
  faqAccordions.forEach((i) => {
    let inAccordion = new Accordion(i, {
      item: ".expandable-section",
      target: ".target",
      control: ".target", // in this case the target is also acting as the control
      panel: ".panel",
      allowMultiple: false,
      attribute: "data-status",
      expanded: "tab-open",
      contracted: "tab-closed",
      prefix: "accordion-",
      transition: "height .35s",
      setFocus: "none", // options: none, item, panel, target, control, first
      hashEnabled: true, // use hash in URL to open accordion item
    });
  });
};

if (faqAccordions) {
  faqAccordion();
}

var cardCarousels = document.querySelectorAll(".card-carousel");
var cardCarousel = function () {
  cardCarousels.forEach((i) => {
    let flkty = new Flickity(i, {
      cellAlign: "left",
      contain: false,
      wrapAround: false,
      resize: true,
      draggable: true,
      imagesLoaded: true,
      prevNextButtons: false,
      pageDots: true,
      imagesLoaded: true,
      hash: true,
    });

    // var cellsButtonGroup = document.querySelector(".label-nav");
    // if (cellsButtonGroup) {
    //   var cellsButtons = utils.makeArray(cellsButtonGroup.children);
    //   cellsButtonGroup.addEventListener("click", function (event) {
    //     var index = cellsButtons.indexOf(event.target);
    //     flkty.select(index);
    //   });

    //   flkty.on("select", function () {
    //     var previousSelectedButton =
    //       cellsButtonGroup.querySelector(".is-selected");
    //     var selectedButton = cellsButtonGroup.children[flkty.selectedIndex];
    //     previousSelectedButton.classList.remove("is-selected");
    //     selectedButton.classList.add("is-selected");
    //   });
    // }
    var nextButton = document.querySelector(".carousel-next");
    if (nextButton) {
      document.querySelector(".carousel-next").addEventListener("click", () => {
        flkty.next();
      });
    }
    setTimeout(function () {
      flkty.resize();
    }, 500);
  });
};
if (cardCarousels) {
  cardCarousel();
}





const lightbox = GLightbox({
  touchNavigation: true,
  loop: false,
  autoplayVideos: true,
  openEffect: "none",
  closeEffect: "none",
});
var galleryCarousel = document.querySelectorAll(".gallery-carousel, .gallery-carousel-wraparound");
if (galleryCarousel) {
  galleryCarousel.forEach((carousel) => {
    let flkty = new Flickity(carousel, {
      draggable: true,
      prevNextButtons: false,
      wrapAround: carousel.classList.contains('gallery-carousel-wraparound'),
      contain: true,
      pageDots: carousel.classList.contains('gallery-carousel'),
      cellAlign: "left",
    });

    flkty.on("dragStart", function () {
      document.querySelectorAll("a.gallery-slide").forEach((slide) => {
        slide.style.pointerEvents = "none";
      });
    });

    flkty.on("dragEnd", function () {
      document.querySelectorAll("a.gallery-slide").forEach((slide) => {
        slide.style.pointerEvents = "all";
      });
    });

    // Add event listener for slide change
    flkty.on("change", function (index) {
      // Get the grandparent element
      const grandparent = carousel.parentElement.parentElement;
      const nextButton = carousel.parentElement.querySelector('.next-slide');
      const prevButton = carousel.parentElement.querySelector('.prev-slide');

      if (index > 0) {
        // Add the "slider-started" class if not on the first slide
        grandparent.classList.add("slider-started");
      } else {
        // Remove the "slider-started" class if on the first slide
        grandparent.classList.remove("slider-started");
      }

      // Check if we're on the last slide
      if (index === flkty.slides.length - 1) {
        nextButton.classList.add('disabled');
      } else {
        nextButton.classList.remove('disabled');
      }
    });

    const nextButton = carousel.parentElement.querySelector('.next-slide');
    if (nextButton) {
    
      nextButton.addEventListener('click', () => {
        flkty.next();
      });
    }

    const prevButton = carousel.parentElement.querySelector('.prev-slide');
    if (prevButton) {
   
      prevButton.addEventListener('click', () => {
        flkty.previous();
      });
    }
  });
}




// Home header typing animation
function initHomeHeaderTyping() {
  const typedElement = document.getElementById('home-header-typed');
  const finalScreen = document.getElementById('home-header-final-screen');
  
  if (!typedElement || !window.homeHeaderData) {
    return;
  }

  const { sentenceStart, sentenceEnds } = window.homeHeaderData;
  
  if (!sentenceEnds || sentenceEnds.length === 0) {
    return;
  }
  
  document.fonts.ready.then(() => {
    const { sentenceStart, sentenceEnds } = window.homeHeaderData;
    
    if (!sentenceEnds || sentenceEnds.length === 0) {
      return;
    }

    typedElement.style.visibility = 'visible';
    typedElement.style.opacity = '1';
    typedElement.style.transform = 'translateY(0)';

  const typed = new Typed('#sentence-end', {
    strings: sentenceEnds,
    typeSpeed: 50,
    backSpeed: 50,
    fadeOut: false,
    backDelay: 2000,
    startDelay: 1000,
    loop: false,
    showCursor: false,
    onComplete: function() {
      // Hide the typed element and show the final screen
      setTimeout(() => {
        typedElement.style.opacity = '0';
        typedElement.style.transform = 'translateY(-20px)';
        typedElement.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
        
        setTimeout(() => {
          typedElement.style.display = 'none';
          finalScreen.classList.remove('hidden');
          finalScreen.style.opacity = '0';
          finalScreen.style.transform = 'translateY(20px)';
          finalScreen.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
          
          // Trigger the animation
          setTimeout(() => {
            finalScreen.style.opacity = '1';
            finalScreen.style.transform = 'translateY(0)';
          }, 100);
        }, 500);
      }, 1000);
    }
  });
  });
}

// Home header background scroll animation
function initHomeHeaderBackground() {
  const backgroundImage = document.getElementById('home-header-background');
  const backgroundContainer = document.getElementById('home-header-background');
  const finalScreen = document.getElementById('home-header-final-screen');
  const typedElement = document.getElementById('home-header-typed');
  
  if (!backgroundImage || !backgroundContainer) {
    return;
  }

  // Set initial border radius based on screen size
  const isMobile = window.innerWidth < 768;
  const initialBorderRadius = isMobile ? '0 0 40px 40px' : '0 0 90px 90px';

  // Set initial state
  gsap.set(backgroundImage, {
    scale: 0.97,
    borderRadius: initialBorderRadius
  });

  // Create scroll-triggered animation with inertia
  gsap.to(backgroundImage, {
    scale: 1,
    borderRadius: '0px',
    ease: "power2.out",
    scrollTrigger: {
      trigger: backgroundContainer,
      start: "top top", 
      end: "bottom 60%",
      scrub: 2, // This creates the inertia effect
      pin: false
    }
  });

  // Update border radius on resize
  window.addEventListener('resize', () => {
    const isMobile = window.innerWidth < 768;
    const newBorderRadius = isMobile ? '0 0 40px 40px' : '0 0 90px 90px';
    gsap.set(backgroundImage, {
      borderRadius: newBorderRadius
    });
  });
}

// Initialize home header typing when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  initHomeHeaderTyping();
  initHomeHeaderBackground();
});

// Also initialize if the function is called after DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    initHomeHeaderTyping();
    initHomeHeaderBackground();
  });
} else {
  initHomeHeaderTyping();
  initHomeHeaderBackground();
}
